import { NgModule } from '@angular/core';
import { TenantsPagesRoutingModule } from './tenants-pages-routing.module';
import { CreateTenantUserModal } from './modals/create-tenant-user/create-tenant-user.modal';
import { EditTenantUserModal } from './modals/edit-tenant-user/edit-tenant-user.modal';
import { TenantUserPlugin } from './plugins/tenant-user/tenant-user.plugin';
import { ChassisModalModule } from '../../modals/modals.module';
import { FormsModule } from '../../forms/forms.module';
import { SupportModule } from '../../support/support.module';

@NgModule({
    imports: [TenantsPagesRoutingModule, ChassisModalModule, FormsModule, SupportModule],
    exports: [],
    declarations: [CreateTenantUserModal, EditTenantUserModal, TenantUserPlugin],
    entryComponents: [CreateTenantUserModal, EditTenantUserModal, TenantUserPlugin],
    providers: [],
})
export class TenantsPagesModule {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/tenants/tenants-pages.module.ts